<template>
  <div>
    <el-carousel :autoplay="false" :interval="5000" :height="height?height:'180px'" :arrow="list.length==1?'never':'hover'" :indicator-position="list.length==1?'none':'outside'">
      <el-carousel-item v-for="resource in list" :key="resource.url">
        <el-image :src="resource.url"  v-if="resource.type=='IMAGE'" fit="scale-down" :preview-src-list="srcList"></el-image>
        <video controls="controls"  v-if="resource.type=='VIDEO'">
          <source :src="resource.url" type="video/mp4">
        </video>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'Resources',
  props: {
    list: Array,
    height:String,
  },
  data(){
    // console.log("this.list",this.list);
    return {
      srcList:this.list.map(d=>d.url)
    }
  },
  created () {
    
  },
  methods:{
    
  } 
}
</script>

<style scoped>
img,video{max-width: 100%;}
</style>
